const axios = require("axios");

var getHocPhiByKhoaId = async (khoaId) => {
	return await axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_KINHPHI}${process.env.VUE_APP_KHOAID}/${khoaId}`,
		)
		.then((response) => response)
		.catch((error) => error.response);
};

export const KinhPhiNhapHocService = {
	getHocPhiByKhoaId,
};
